import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { HistoryToggles } from './HistoryToggles.tsx'

export const BackToMapBar: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className="flex justify-center items-center gap-4 pb-2">
      <button
        className="btn btn-sm btn-primary"
        onClick={() => navigate('/map')}
      >
        <FontAwesomeIcon icon={faArrowLeft} className="mr-1" />
        Back to Map
      </button>
      <HistoryToggles />
    </div>
  )
}
